import styled from "styled-components";

import {
  DefaultParagraphLargeFactory,
  DefaultParagraphSmallFactory,
  DefaultTitleSmallFactory,
} from "../../../../components/Habitacional/core/Typograph/Typograph.Style";

export const ProductContentContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",

  [theme.breakpoint.lg()]: {
    gap: "60px",
  },
}));

export const ProductContentTitle = styled.h3(({ theme }) => ({
  ...DefaultTitleSmallFactory({ theme }),
  fontWeight: "600",
}));

export const ProductContentDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),

  strong: {
    ...DefaultParagraphLargeFactory({ theme }),
    fontWeight: 700,
  },
}));

export const ProductContentList = styled.div(({ theme, $hiddenBorder }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",

  [theme.breakpoint.lg()]: {
    flexDirection: "row",

    ".tab-item + .tab-item": {
      borderLeft: !$hiddenBorder
        ? `1px solid ${theme.color.line.medium}`
        : "none",
      paddingLeft: "32px",
    },
  },
}));

export const ProductContentItem = styled.div(() => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  paddingRight: "32px",
}));

export const ProductContentItemHeader = styled.header(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
}));

export const ProductContentItemLink = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",

  a: {
    ...DefaultParagraphLargeFactory({ theme }),
    width: "fit-content",
    fontWeight: 600,
    gap: "16px",
  },
}));

export const ProductContentItemLinkDescription = styled.p(({ theme }) => ({
  fontWeight: 400,
  lineHeight: "150%",

  strong: {
    ...DefaultParagraphSmallFactory({ theme }),
    fontWeight: 700,
  },
}));
